import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/en/industries/companion-diagnostics")({
  head: () => buildRouteHead("/en/industries/companion-diagnostics"),
  component: SolutionDetail,
});

